@if (isVisible) {
<div class="alert alert-warning alert-dismissible fade show" role="alert">
  <span class="warning-alert"></span> <div><strong>{{title}}</strong>{{message}}</div>
  @if (allowClose) {
<button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="hide()">
    <span aria-hidden="true">&times;</span>
  </button>
}
</div>
}
